<template>
  <div id="qr-code-full-region-reader-d8i3jsu"></div>
</template>

<script>
import {Html5Qrcode, Html5QrcodeSupportedFormats} from "html5-qrcode";
import {Toast} from "vant";

const idgen = (() => {
  let id = 1;
  return () => {
    return id++;
  }
})();

export default {
  name: "VgScanQrCode",
  props: {
    qrbox: Number,
    fps: Number,
    aspectRatio: Number,
  },
  data() {
    return {
      e: null,
      decodedText: null,
      decodedResult: null,
      errorMessage: null,
      error: null,
      id: `qr-code-full-region-${idgen()}`,
      html5QrCode: null,
      scanning: false,
    }
  },
  activated() {
    if (this.html5QrCode) {
      this.html5QrCode.resume()
    } else {
      this.start()
    }
  },
  deactivated() {
    this.html5QrCode.pause(true)
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    start() {
      if (this.scanning) {
        return
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const qrCodeSuccessCallback = (decodedText, decodedResult) => {
        /* handle success */
        this.decodedText = decodedText;
        this.decodedResult = decodedResult;
        this.$emit('success-text', decodedText)
      };
      const qrCodeErrorCallback = (errorMessage, error) => {
        this.errorMessage = errorMessage;
        this.error = error;
        this.$emit('error-message', errorMessage);
      }
      try {
        if (!this.html5QrCode) {
          this.html5QrCode = new Html5Qrcode("qr-code-full-region-reader-d8i3jsu", {
            formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE],
          });
        }
        this.html5QrCode.start(
            {facingMode: "environment"},
            // this.cameraId,
            {
              fps: this.fps ? this.fps : 10,
              qrbox: this.qrbox ? this.qrbox : null,
              aspectRatio: this.aspectRatio ? this.aspectRatio : null,
            },
            qrCodeSuccessCallback,
            qrCodeErrorCallback)
            .then(() => {
              this.scanning = true
            })
            .catch((e) => {
              this.e = e;
              this.$emit('error-message', e.toString());
              this.stop()
            })
            .finally(() => {
              Toast.clear()
            })
      } catch (e) {
        this.e = e;
        this.$emit('error-message', e.toString());
      } finally {
        Toast.clear()
      }
      // const html5QrcodeScanner = new Html5QrcodeScanner(
      //     "qr-code-full-region", config);
      // html5QrcodeScanner.render(onScanSuccess);
    },
    stop() {
      if (!this.scanning) {
        return
      }
      this.html5QrCode.stop().then((ignore) => {
        this.scanning = false
        // QR Code scanning is stopped.
        console.log(ignore);
      }).catch((err) => {
        // Stop failed, handle it.
        console.log(err);
      });
    }
  }
}
</script>
